import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Countdown, { zeroPad } from "react-countdown-now";
import { connect } from "react-redux";
import { toast } from "react-toast";
import { SaveUserStateToServerHelper } from "./Helper";

import { Translate } from "react-redux-i18n";

import {
  changeView,
  dataEntryTestCompleted,
  nextExam,
  nextSection,
  resetDataEntryForm,
  resetTempDataEntryData,
  setIsPracticeDone,
  setIsTypingStarted,
  setRemainingTime,
  setTimeExpired,
  typingTestCompleted,
} from "./../actions/assessment";
import clockIcon from "./../assets/img/illus-clock.svg";
import Button from "./ui/Buttons/Button";

export class Timer extends Component {
  clockRef = null;

  state = {
    time_limit: 0,
    section: null,
    time_expire_msg: "timer_exp",
    // typing_time_limit: Date.now() + 1 * 60 * 1000,
    typing_completed: false,
    typing_time_limit: ["typing_test", "data_entry_test"].includes(
      this.props.view,
    )
      ? Date.now() + this.props.time_limit * 60 * 1000
      : Date.now() + 2 * 60 * 1000,
    notified: false,
  };

  constructor(props) {
    super(props);
    this.setClockRef = this.setClockRef.bind(this);
    this.start = this.start.bind(this);
    this.pause = this.pause.bind(this);
  }

  start = () => {
    this.clockRef.start();
  };

  pause = () => {
    this.clockRef.pause();
  };

  setClockRef(ref) {
    // When the `Clock` (and subsequently `Countdown` mounts
    // this will give us access to the API
    this.clockRef = ref;
  }

  handleContinue = () => {
    let exams = this.props.assessment.exams;

    if (this.props.is_ms_test) {
      this.props.nextSection(this.state.section);
      this.props.setTimeExpired(false);
      this.start();
      return;
    }

    if (
      [
        "Typing Test V1",
        "Typing Test V2",
        "Data Entry V1",
        "Data Entry V2",
      ].includes(this.props.exam_name)
    ) {
      if (exams[this.props.assessment.exam_index].is_practice_done) {
        this.props.showTypingInstruction();
        this.props.setIsTypingStarted(false);
      }
      if (exams[this.props.assessment.exam_index].is_test_done) {
        this.props.nextExam();
        this.props.resetDataEntryForm();
        // this.props.finishTyping();
      }
    } else {
      this.props.nextExam();
    }
  };

  componentDidMount = () => {
    SaveUserStateToServerHelper(this.props.assessment);
    if (this.props.is_ms_test) {
      this.setState({
        section: this.props.current_question.section.id,
        time_expire_msg: "section_timer_exp",
      });
    }
    if (
      [
        "Typing Test V1",
        "Typing Test V2",
        "Data Entry V1",
        "Data Entry V2",
      ].includes(this.props.exam_name) &&
      this.props.is_typing_started
    ) {
      const start_time = this.props.assessment.start_time;
      const diff = Date.now() - start_time;
      let total_time_in_ms = this.props.time_limit * 60 * 1000;
      if (this.props.view === "practice_test") {
        total_time_in_ms = 2 * 60 * 1000;
      }
      const remaining = Date.now() - diff + total_time_in_ms;

      this.setState({
        typing_time_limit: remaining,
      });
      if (!this.props.is_practice_done || !this.props.is_test_done) {
        this.start();
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    SaveUserStateToServerHelper(this.props.assessment);
    if (this.props.is_ms_test) {
      if (this.state.section !== this.props.current_question.section.id) {
        const time_in_seconds =
          this.props.current_question.section.time_limit * 60;
        const total_time = time_in_seconds * 1000;
        const remaining = Date.now() + total_time;

        this.setState({
          section: this.props.current_question.section.id,
          time_limit: remaining,
        });
      }
    }
    if (prevProps.is_typing_started !== this.props.is_typing_started) {
      if (
        [
          "Typing Test V1",
          "Typing Test V2",
          "Data Entry V1",
          "Data Entry V2",
        ].includes(this.props.exam_name) &&
        // !this.props.is_practice_done &&
        this.props.is_typing_started
      ) {
        if (!this.props.is_practice_done || !this.props.is_test_done) {
          this.start();
        }
      }
    }
  }

  onStart = () => {
    this.props.setTimeExpired(false);
    let time_in_seconds = this.props.time_in_seconds;
    if (this.props.view === "practice_test") {
      time_in_seconds = 2 * 60;
    }
    const start_time = this.props.assessment.start_time;
    const diff = Date.now() - start_time;

    if (this.props.is_ms_test) {
      time_in_seconds = this.props.current_question.section.time_limit * 60;
    }

    const total_time = time_in_seconds * 1000;
    const remaining = Date.now() - diff + total_time;

    return this.setState({
      time_limit: remaining,
    });
  };

  onComplete = () => {
    const has_next_exam =
      typeof this.props.assessment.exams[
        this.props.assessment.exam_index + 1
      ] !== "undefined";
    this.props.setTimeExpired(true);

    if (this.props.is_ms_test) {
      //-- if time expire move to next section
      this.setState({ time_expire_msg: "section_timer_exp" });
      return;
    }

    this.props.setTimeExpired(true);
    if (!has_next_exam) {
      this.handleContinue();
      return;
    }
  };

  onTypingComplete = () => {
    const has_next_exam =
      typeof this.props.assessment.exams[
        this.props.assessment.exam_index + 1
      ] !== "undefined";
    let exams = this.props.assessment.exams;
    let time_expire_msg = "timer_exp";

    if (this.props.view === "practice_test") {
      if (["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name)) {
        this.props.assessment.data_entry = {
          form_index: 0,
          rotation_count: 0,
          data_index: 0,
        };
      }
      exams[this.props.assessment.exam_index].is_practice_done = true;
    } else {
      exams[this.props.assessment.exam_index].is_test_done = true;
    }
    this.props.resetTempDataEntryData();

    if (
      ["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name) &&
      this.props.view === "typing_test"
    ) {
      const typing_question_id =
        exams[this.props.assessment.exam_index].questions[
          this.props.assessment.question_index
        ].id;
      const typing_test_result = this.props.assessment.typing_test_result;
      const has_question_id = typing_test_result.some(
        (obj) => obj.question_id === typing_question_id,
      );

      if (!has_question_id) {
        this.props.typingTestCompleted();
      }
    }

    if (
      ["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name) &&
      this.props.view === "data_entry_test"
    ) {
      const data_entry_question_id =
        exams[this.props.assessment.exam_index].questions[
          this.props.assessment.question_index
        ].id;
      const data_entry_test_result =
        this.props.assessment.data_entry_test_result;
      const has_question_id_ = data_entry_test_result.some(
        (obj) => obj.question_id === data_entry_question_id,
      );

      if (!has_question_id_) {
        this.props.dataEntryTestCompleted();
      }
    }

    if (has_next_exam) {
      time_expire_msg = "typing_test_timer_exp";
    }

    this.setState({
      time_expire_msg:
        this.props.view === "practice_test"
          ? ["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name)
            ? "practice_data_entry_test_timer_exp"
            : "practice_typing_test_timer_exp"
          : time_expire_msg,
      typing_completed: true,
    });
    return;
  };

  handleTick = ({ minutes, seconds }) => {
    if (!this.notified && minutes === 1 && seconds === 0) {
      toast.warn(<Translate value="time_left" />, {
        backgroundColor: "#ffc107",
        color: "#fff",
      });
      this.setState({
        notified: true,
      });
    }
  };

  renderer = ({ total, hours, minutes, seconds, completed }) => {
    const i18n = require("react-redux-i18n").I18n;

    // Render a countdown
    let strSeconds = zeroPad(seconds);
    let strMinutes = zeroPad(minutes);
    // let strHours = zeroPad(hours);

    return (
      <div>
        {completed && (
          <Modal
            show={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="text-center mt-5 mb-5">
                <img src={clockIcon} className="icon" alt={i18n.t("expired")} />
                <br />
                <br />
                <h2 className="title">
                  <Translate value={this.state.time_expire_msg} />
                </h2>
                {/* <p>You have one more attempt.</p> */}

                <div className="button-wrap mt-md-5">
                  {/* <button
                    className="btn btn-success btn-lg"
                    // data-dismiss="modal"
                    onClick={this.handleContinue}
                  >
                    <Translate value="cont" />
                  </button> */}

                  <Button variant="primary" onClick={this.handleContinue}>
                    <Translate value="cont" />
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}

        <input type="hidden" id="remaining_time" value={total} />
        <div className="flip-clock-wrapper">
          <ul className="flip">
            <li className="flip-clock-active">
              <div className="inn">{strMinutes[0]}</div>
            </li>
          </ul>
          <ul className="flip">
            <li className="flip-clock-active">
              <div className="inn">{strMinutes[1]}</div>
            </li>
          </ul>
          <span className="flip-clock-divider seconds">
            <span className="flip-clock-label">
              <Translate value="timer_sec" />
            </span>
            <span className="flip-clock-dot top"></span>
            <span className="flip-clock-dot bottom"></span>
          </span>
          <ul className="flip">
            <li className="flip-clock-active">
              <div className="inn">{strSeconds[0]}</div>
            </li>
          </ul>
          <ul className="flip">
            <li className="flip-clock-active">
              <div className="inn">{strSeconds[1]}</div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.props.is_timed && this.props.view === "examination" && (
          <div className="timer">
            <span className="timer-text">
              <Translate value="timer_timed" />
            </span>
            <Countdown
              date={this.state.time_limit}
              onComplete={this.onComplete}
              onStart={this.onStart}
              renderer={this.renderer}
              ref={this.setClockRef}
              onTick={this.handleTick}
            />
          </div>
        )}
        {this.props.is_timed &&
          ["practice_test", "data_entry_test", "typing_test"].includes(
            this.props.view,
          ) && (
            <div className="timer">
              <span className="timer-text">
                <Translate value="timer_timed" />
              </span>
              <Countdown
                autoStart={false}
                date={this.state.typing_time_limit}
                onComplete={this.onTypingComplete}
                // onStart={this.onStart}
                renderer={this.renderer}
                ref={this.setClockRef}
                onTick={this.handleTick}
              />
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  view: state.assessment.view,
  is_timed: state.assessment.exams[state.assessment.exam_index].timed,
  time_limit: state.assessment.exams[state.assessment.exam_index].time_limit,
  time_in_seconds:
    state.assessment.exams[state.assessment.exam_index].time_limit * 60,
  current_exam: state.assessment.exams[state.assessment.exam_index],
  current_question:
    state.assessment.exams[state.assessment.exam_index].questions[
      state.assessment.question_index
    ],
  is_ms_test: state.assessment.exams[state.assessment.exam_index].is_ms_test,
  is_time_expired: state.assessment.is_time_expired,
  test_type: state.assessment.exams[state.assessment.exam_index].test_type,
  exams: state.assessment.exams,
  exam_index: state.assessment.exam_index,
  exam_name: state.assessment.exams[state.assessment.exam_index].name,
  is_practice_done:
    state.assessment.exams[state.assessment.exam_index].is_practice_done,
  is_test_done:
    state.assessment.exams[state.assessment.exam_index].is_test_done,
  is_typing_started: state.assessment.is_typing_started,
});

const mapDispatchToProps = (dispatch) => ({
  setTimeExpired: (is_time_expired) =>
    dispatch(setTimeExpired(is_time_expired)),
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
  nextSection: (section) => dispatch(nextSection(section)),
  setIsPracticeDone: (bool) => dispatch(setIsPracticeDone(bool)),
  showTypingInstruction: () => dispatch(changeView("instruction")),
  setIsTypingStarted: (value) => dispatch(setIsTypingStarted(value)),
  typingTestCompleted: () => dispatch(typingTestCompleted()),
  dataEntryTestCompleted: () => dispatch(dataEntryTestCompleted()),
  resetTempDataEntryData: () => dispatch(resetTempDataEntryData()),
  resetDataEntryForm: () => dispatch(resetDataEntryForm()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Timer);
